import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_SNOW_COLOR } from "@erikwatson/snowfall";
import { Colour } from "../../../colour/colour";
import { Control } from "../../../control/control";
import { useDispatch } from "react-redux";
import { setColour } from '../../../../features/config/config.slice';
export const SnowflakeColour = ({ index, layer }) => {
    const dispatch = useDispatch();
    return (_jsx(Control, { name: "Colour", tooltip: "The colour of the snowflakes", showOutput: true, reset: () => {
            const colour = DEFAULT_SNOW_COLOR;
            dispatch(setColour({
                index,
                colour
            }));
        }, value: layer.colour, onChange: (event) => dispatch(setColour({
            index,
            colour: event.target.value,
        })), children: _jsx(Colour, {}) }));
};
